import { Link } from "wouter";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PageContainer } from "@/components/layout/PageContainer";

export default function EmailRefuse() {
  return (
    <PageContainer size="read">
        <Link href="/">
          <Button variant="ghost" className="mb-6" data-testid="button-back">
            <ArrowLeft className="h-4 w-4 mr-2" />
            목록으로
          </Button>
        </Link>

        <Card>
          <CardHeader>
            <CardTitle className="text-2xl font-bold">이메일 무단 수집 거부</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <p className="text-muted-foreground">
              OZK News는 이메일 주소의 무단 수집을 거부합니다.
              전자우편 수집 프로그램 또는 기타 기술적 장치를 이용하여 이메일 주소를 무단으로 수집하는 행위를 금지하며, 위반 시 관련 법령에 따라 처벌될 수 있습니다.
            </p>

            <div>
              <h3 className="text-lg font-semibold mb-3">1. 이메일 수집 거부 안내</h3>
              <p className="text-muted-foreground">
                본 웹사이트에 게시된 이메일 주소는 사전 동의 없이 수집·저장·배포할 수 없습니다.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-3">2. 위반 시 법적 대응</h3>
              <p className="text-muted-foreground">
                위반 시 스팸 방지법 및 호주 정보보호법에 따라 처벌될 수 있으며, OZK News는 법적 조치를 취할 수 있습니다.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-3">3. 신고</h3>
              <p>
                이메일 수집 시도 또는 스팸 관련 신고:{" "}
                <a href="mailto:ozknews.com@gmail.com" className="text-primary hover:underline">
                  ozknews.com@gmail.com
                </a>
              </p>
            </div>
          </CardContent>
        </Card>
    </PageContainer>
  );
}
